import { alpha } from "@material-ui/core"
import { createGlobalStyle } from "styled-components"
import { theme } from "../../theme"

const ScrollBarStyles = createGlobalStyle`
  /* width */
	::-webkit-scrollbar {
		width: 18px;
		padding: 8px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: white;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background: ${alpha(theme.palette.primary.main, 0.5)};
		border: 4px solid white;
		border-radius: 50px;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: ${alpha(theme.palette.primary.main, 0.8)};
	}

	::-webkit-scrollbar-thumb:active {
		background: ${alpha(theme.palette.primary.main, 0.95)};
	}
`

export default ScrollBarStyles